export enum GrpEnrollmentStatus {
  ACTIVE = "ACTIVE",
  UNENROLLED = "UNENROLLED"
}

export const PENDING_DOLLARS_PLACEHOLDER = "Not yet";

export const ENROLLMENT_STATUS_LABELS: Record<GrpEnrollmentStatus, string> = {
  [GrpEnrollmentStatus.ACTIVE]: "Active",
  [GrpEnrollmentStatus.UNENROLLED]: "Unenrolled"
};

export interface GrpEnrollmentPerson {
  id: string;
  firstName: string;
  lastName: string;
  displayName: string;
  profilePhoto?: string | null;
  pgaId?: string | null;
}

export interface GrpEnrollmentNode {
  id: string;
  memberNumber: string;
  accountOpenedOn: string;
  status: GrpEnrollmentStatus;
  classification?: string | null;
  state?: string | null;
  facilityName?: string | null;
  person?: GrpEnrollmentPerson | null;
}

export interface GrpEnrollmentRow extends GrpEnrollmentNode {
  pendingDollars: string;
  enrolledOnLabel: string;
}
